import { BusinessStep1Details } from "./business/BusinessStep1Details";
import { BusinessStep2Income } from "./business/BusinessStep2Income";
import { BusinessStep3Expenses } from "./business/BusinessStep3Expenses";
import { BusinessStep4CostOfGoodsSold } from "./business/BusinessStep4CostOfGoodsSold";
import { BusinessStep5Vehicle } from "./business/BusinessStep5Vehicle";
import { BusinessStep6OtherAndDocuments } from "./business/BusinessStep6OtherAndDocuments";
import { useWizard } from "../context/WizardContext";

const STEPS = [
  BusinessStep1Details,
  BusinessStep2Income,
  BusinessStep3Expenses,
  BusinessStep4CostOfGoodsSold,
  BusinessStep5Vehicle,
  BusinessStep6OtherAndDocuments,
];

export function BusinessWizardSteps() {
  const { currentStepIndex } = useWizard();
  const Step = STEPS[currentStepIndex];
  if (!Step) return null;
  return <Step />;
}
